import React, { useEffect, useState } from "react";
import AuthContainer from "../../containers/Auth";
import { useNavigate } from "react-router-dom";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../service/validation/businessType";
import MultiSelect from "../../components/MultiSelect";
import { MASTER_URL } from "../../common/common";
import { ApiService } from "../../service/api.service";
import { FormData } from "../../service/interfaces/ApiResponse.interface";

const BusinessType: React.FC = () => {
  const apiService = new ApiService();
  const navigate = useNavigate();
  const [transporter, setTransporter] = React.useState([]);
  const [driver, setDriver] = React.useState([]);
  const [clearanceForwarding, setClearanceForwarding] = React.useState([]);
  const [commonError, setCommonError] = useState<boolean>(false);
  const getBusinessType = async () => {
    try {
      const response: any = await apiService.getApi(
        `${MASTER_URL}/business/type-route?key=Buisness Type`
      );
      if (response.status === "200") {
        const data = response?.body;
        if (data["Clearance and forwarding segment"])
          setClearanceForwarding(
            data["Clearance and forwarding segment"].map((item: any) => ({
              label: item.value,
              value: item.value,
              type: item.type.type,
              description: item.type.description,
              metaId: item.metaId,
            }))
          );
        if (data["Driver segment"])
          setDriver(
            data["Driver segment"].map((item: any) => ({
              label: item.value,
              value: item.value,
              type: item.type.type,
              description: item.type.description,
              metaId: item.metaId,
            }))
          );
        if (data["Transporter segment"])
          setTransporter(
            data["Transporter segment"].map((item: any) => ({
              label: item.value,
              value: item.value,
              type: item.type.type,
              description: item.type.description,
              metaId: item.metaId,
            }))
          );
      }
    } catch (error) {
      console.error("Business Type Error:", error);
    }
  };

  useEffect(() => {
    getBusinessType();
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm<FormData>({
    defaultValues: {
      clearanceForwardingSegment: undefined, // Allow undefined
      transporterSegment: undefined, // Allow undefined
      driverSegment: undefined, // Allow undefined
    },
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  // Watch selected values for conditional logic
  const clearanceForwardingSegment = useWatch({
    control,
    name: "clearanceForwardingSegment",
  });
  const transporterSegment = useWatch({
    control,
    name: "transporterSegment",
  });
  const driverSegment = useWatch({
    control,
    name: "driverSegment",
  });

  // Logic to disable segments based on selections
  const isDriverSelected = (driverSegment?.length ?? 0) > 0;
  const isTransporterOrClearanceSelected =
    (clearanceForwardingSegment?.length ?? 0) > 0 ||
    (transporterSegment?.length ?? 0) > 0;

  const onSubmit = async (data: FormData) => {
    console.log("Form submitted:", data);
    const businessTypeIds = [
      ...(data?.transporterSegment ?? []).map((item) => item?.metaId),
      ...(data?.clearanceForwardingSegment ?? []).map((item) => item?.metaId),
      ...(data?.driverSegment ?? []).map((item) => item?.metaId),
    ];
    try {
      if (businessTypeIds.length > 0) {
        localStorage.setItem("businessType", JSON.stringify(businessTypeIds));
        if (
          data.driverSegment &&
          data.driverSegment.length > 0 &&
          data.driverSegment[0].label === "Owner come Driver"
        ) {
          navigate("/owner-kyc");
        } else if (
          data.driverSegment &&
          data.driverSegment.length > 0 &&
          data.driverSegment[0].label === "Driver"
        ) {
          navigate("/driver-kyc");
        } else {
          navigate("/gst-verfication");
        }
      }
    } catch (error) {
      console.error("Business Type Error:", error);
    }
  };
  return (
    <AuthContainer>
      <div className="flex w-full min-h-[90vh] bg-white font-poppins rounded-[21.25px]">
        <div className="w-full">
          <div className="md:mx-[2rem] my-[2rem] ">
            <div className="ml-8">
              <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
                logo
              </div>
              <br />
              <p className="font-[700] text-[20px] font-poppins track-[1%]">
                Welcome aboard 👋
              </p>
              <p className="font-[600] font-poppins text-[16px] track-[1%] text-[#282828]">
                Business Type/Nature
              </p>
              <p className="font-[400] text-[14px] track-[1%] text-[#282828]">
                Multi-selection option
              </p>
            </div>
            <br />
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col gap-5 min-h-[300px]"
            >
              <div>
                <Controller
                  name="clearanceForwardingSegment"
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      options={clearanceForwarding}
                      selectedOptions={field.value || []}
                      onChange={field.onChange}
                      label="Clearance & Forwarding Segment"
                      isDisabled={isDriverSelected}
                      isMultiSelect={true}
                    />
                  )}
                />
                {errors.clearanceForwardingSegment && (
                  <p className="text-red-500 text-sm">
                    {errors.clearanceForwardingSegment.message}
                  </p>
                )}
              </div>
              <div>
                <Controller
                  name="transporterSegment"
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      options={transporter}
                      selectedOptions={field.value || []}
                      onChange={field.onChange}
                      label="Transporter Segment"
                      isDisabled={isDriverSelected}
                      isMultiSelect={true}
                    />
                  )}
                />
                {errors.transporterSegment && (
                  <p className="text-red-500 text-sm">
                    {errors.transporterSegment.message}
                  </p>
                )}
              </div>
              <div>
                <Controller
                  name="driverSegment"
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      options={driver}
                      selectedOptions={field.value || []}
                      onChange={field.onChange}
                      label="Driver Segment"
                      isDisabled={isTransporterOrClearanceSelected}
                      isMultiSelect={false}
                    />
                  )}
                />
               {("formError" in errors &&
  !clearanceForwardingSegment?.length &&
  !transporterSegment?.length &&
  !driverSegment?.length) && (
  <p className="text-red-500 text-sm text-center mt-2">
    {(errors as any).formError?.message}
  </p>
)}




              </div>
              <div className="flex items-center justify-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  onClick={() => console.log(errors,"error")}
                  className="mt-4 p-2 w-[245px] h-[45px] font-[400] text-[16px] leading-[22.96px] tracking-[1%] bg-[#444FBD] rounded-[20px] text-white"
                >
                  {isSubmitting ? "Verifying..." : "Next"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default BusinessType;
